import React from 'react';
import AirbnbBookingWidget from './AirbnbBookingWidget';
import { Star, Shield, Award } from 'lucide-react';

const BookingSection = ({ property }) => {
  return (
    <section id="booking-section" className="py-10 md:py-16 px-4 md:px-6 bg-gradient-to-b from-background to-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          
          {/* Left - Why Book Direct Info */}
          <div className="animate-fade-in">
            <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground mb-3 md:mb-4" style={{fontFamily: 'Cormorant Garamond, Georgia, serif'}}>
              Book Your Stay
            </h2>
            <p className="text-muted-foreground mb-6 md:mb-8 text-sm md:text-lg">
              Select your dates and we'll take you directly to Airbnb to complete your reservation securely.
            </p>

            {/* Trust badges */}
            <div className="space-y-3 md:space-y-4">
              <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-white rounded-xl shadow-sm border border-border/50">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Shield className="w-5 h-5 md:w-6 md:h-6 text-green-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground text-sm md:text-base">Secure Booking</h3>
                  <p className="text-xs md:text-sm text-muted-foreground">Protected by Airbnb's payment system</p>
                </div>
              </div>

              <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-white rounded-xl shadow-sm border border-border/50">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Star className="w-5 h-5 md:w-6 md:h-6 text-yellow-600 fill-yellow-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground text-sm md:text-base">4.99 Star Rating</h3>
                  <p className="text-xs md:text-sm text-muted-foreground">{property.reviewCount}+ verified guest reviews</p>
                </div>
              </div>

              <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-white rounded-xl shadow-sm border border-border/50">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-pink-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Award className="w-5 h-5 md:w-6 md:h-6 text-pink-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground text-sm md:text-base">Guest Favourite</h3>
                  <p className="text-xs md:text-sm text-muted-foreground">One of the most loved homes on Airbnb</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Booking Widget */}
          <div className="flex justify-center lg:justify-end animate-fade-in-up animation-delay-200">
            <AirbnbBookingWidget property={property} />
          </div>

        </div>
      </div>
    </section>
  );
};

export default BookingSection;
